// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aa5b9cb8","455":"88930c68","977":"134ea4bc"}[chunkId] + ".chunk.js";
};